import { Tooltip } from "@mui/material";
import React from "react";
import Typography from "../../../Typography";
import { More as OptionIcon } from "iconsax-reactjs";
import LightTooltip from "../../../LightTooltip";

import { ReactComponent as Bullet } from "../../../../build/images/TimeCounter/Bullet.svg";
import { ReactComponent as Timer } from "../../../../build/images/TimeCounter/timer.svg";
import { useTimeCounter } from "../../../../hooks/useTimeCounter";
import TimeCounterMinute from "../../../../containers/TimeCounterMinute";
import { formatTextAndUnicode } from "../../../../utils/formatTextAndUnicode";

const CardItem = ({
  call,
  selectedCall,
  style,
  onSelectCall,
  search,
  renderProfilePicture,
  destinomsg,
  lastMessageInfo,
  // createJSON,
  dateExhib,
  lastMsg,
  msgIcon,
  tempoExcedido,
  renderTagInfo,
  renderMoreOptions,
  isOpenMoreOptions,
  handleCloseMoreOptions,
  handleOpenMoreOptions,
}) => {
  const { time, days } = useTimeCounter(call ? call.recuperationtime : null);
  return (
    <div
      className={`card-chats ${
        call.idatendimento === selectedCall.idatendimento ? "active" : ""
      } `}
      style={style}
      onClick={() => {
        onSelectCall(call, search);
      }}
    >
      <div className="card-chats__main">
        {renderProfilePicture(call.idmidia, call, destinomsg, lastMessageInfo)}
        <div className="card-chats__infos">
          <div className="card-chats__infos-infoMsg" onClick={() => {}}>
            <div className="name-time" style={{ overflow: "hidden" }}>
              <Tooltip
                title={
                  call.cliente ? (
                    <span className="tippy-msg">
                      {formatTextAndUnicode(call.cliente)}
                    </span>
                  ) : (
                    ""
                  )
                }
                placement="top"
              >
                <div className="name-info-container">
                  <Typography.H4 className={"name-info"} color={"gray-600"}>
                    {formatTextAndUnicode(call.cliente)}
                  </Typography.H4>
                </div>
              </Tooltip>
              {/* <Tooltippy
                  content={call.cliente ? formatTextAndUnicode(call.cliente) : ""}
                >
                  <Typography.H4 className={"name-info"} color={"gray-600"}>
                    {formatTextAndUnicode(call.cliente)}
                  </Typography.H4>
                </Tooltippy> */}
              {call.idatendimento !== "voice" && (
                <div
                  className="datetime datetimenew"
                  style={{ flex: "0 0 auto", minWidth: "max-content" }}
                >
                  <span>{dateExhib}</span>
                  <div className="datetimenew__time-counter">
                    <Bullet />
                    <Timer />
                    <TimeCounterMinute horario={time} day={days} />
                  </div>
                </div>
              )}
            </div>
            <div className="message-tag">
              {lastMsg && (
                <Tooltip
                  placement="bottom"
                  title={<span className="tippy-msg">{lastMsg}</span>}
                >
                  <div
                    key={lastMsg + msgIcon}
                    className={`preview-container${
                      tempoExcedido ? " less-width" : ""
                    }`}
                  >
                    {msgIcon}
                    <Typography.H5
                      className={`preview${msgIcon ? " less-width" : ""}`}
                      color={"gray-180"}
                    >
                      {lastMsg}
                    </Typography.H5>
                  </div>
                </Tooltip>
                // <Tooltippy
                //   placement="top"
                //   content={<span className="tippy-msg">{lastMsg}</span>}
                // >
                //   <div
                //     key={lastMsg + msgIcon}
                //     className={`preview-container${
                //       tempoExcedido ? " less-width" : ""
                //     }`}
                //   >
                //     {msgIcon}
                //     <Typography.H5
                //       className={`preview${msgIcon ? " less-width" : ""}`}
                //       color={"gray-180"}
                //     >
                //       {lastMsg}
                //     </Typography.H5>
                //   </div>
                // </Tooltippy>
              )}
              {renderTagInfo(call, tempoExcedido)}
            </div>
          </div>
          {call.idatendimento !== "voice" && (
            <LightTooltip
              title={renderMoreOptions()}
              placement="right"
              open={isOpenMoreOptions}
              onClose={() => {
                handleCloseMoreOptions();
              }}
            >
              <div
                className={`action tippy-context-menu${
                  isOpenMoreOptions ? " active" : ""
                }`}
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  handleOpenMoreOptions();
                }}
              >
                <OptionIcon variant="outline" color="#757575" />
              </div>
            </LightTooltip>
          )}
        </div>
      </div>
    </div>
  );
};

export default CardItem;
